import { Routes } from "@angular/router";
import { AuthGuard } from "../../shared/authguards/auth.guard";
import { epakRoleGuard } from "../../shared/authguards/epak-role.guard";
import { reviewDraftGuard } from "../../shared/authguards/review-draft.guard";

export const TERMINATE_ROUTES: Routes = [
  {
    path: "terminate-leave",
    loadComponent: () => import("./terminate.component").then(m => m.TerminateComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    children: [
      {
        path: "",
        loadComponent: () => import("./terminate-info/terminate-info.component").then(m => m.TerminateInfoComponent),
        data: { title: "pageTitles.terminateLeave" },
      },
      {
        path: "review",
        loadComponent: () => import("./terminate-review/terminate-review.component").then(m => m.TerminateReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.terminateLeaveReview" },
      },
      {
        path: "message",
        loadComponent: () => import("../message/message.component").then(m => m.MessageComponent),
        data: { title: "pageTitles.terminateLeaveMessages" },
      },
      {
        path: "submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
    ],
  },
];
